import React from "react";
import styled from "styled-components";

const MainDiv = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin: 2em 3em 2em 3em;
`;

const ContentDiv = styled.div``;

const Title = styled.h2``;

const Paragraph = styled.p``;

function PrivacyPolicy() {
  return (
    <MainDiv>
      <ContentDiv>
        <Title>HairQ Data Protection Policy</Title>
        <Paragraph>
          HairQ is a company registered in England and Wales. We are committed
          to complying with all requirements of the Data Protection Act 1998
          (‘Act’) and the General Data Protection Regulation (Regulation (EU)
          2016/679) (‘GDPR’) as it relates to our business. In summary, personal
          data shall be:
          <ul>
            <li>collected and used for specified purposes</li>
            <li>processed lawfully, fairly and in a transparent manner;</li>
            <li>accurate and kept up to date;</li>
            <li>
              appropriately secured against unauthorised or unlawful processing
              and against accidental loss, destruction or damage.
            </li>
          </ul>
          HairQ, our staff and our service partners, who process or use personal
          data on behalf of HairQ must comply and be able to demonstrate
          compliance with these principles and ensure that they are followed at
          all times
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Overview</Title>
        <Paragraph>
          Maintaining the security of your data is a priority at HairQ and we
          are committed to respecting your privacy rights. We shall always
          observe all legal requirements when dealing with any aspect of the
          data of our customers and any business partners. And always disclose
          to them the data we collect about them and how we use it. This policy
          applies whether on mobile device, online or whatever other electronic
          method. While our service is primarily electronic the policy applies
          even to non-electronic data. We set out below:
          <ul>
            <li>How the data is used</li>
            <li>Nature of personal data collected</li>
            <li>Respect and assurance of privacy</li>
            <li>Legal rights to personal data</li>
          </ul>
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>How We Use Your Data</Title>
        <Paragraph>
          HairQ uses your personal data in order to provide online services to
          you, provide you with a unique web experience, manage your account
          details, to maintain your confidentiality and to facilitate our own
          internal research purposes
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Personal Data Collected</Title>
        <Paragraph>
          HairQ collects the following information about you - name, phone
          number, postal address and e-mail address. Some data are collected
          directly when you set up your account or via emails or texts sent to
          our server.
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Our Controls to Safeguard your Privacy</Title>
        <Paragraph>
          HairQ is committed to keeping your personal data safe and secure. We
          encrypt the data, carry out regular assessment of service partners,
          and use latest available software tools for data security and virus
          protection.
        </Paragraph>
      </ContentDiv>
      <Title>Sharing data with third parties</Title>

      <ContentDiv>
        <Title>1. Our service providers and suppliers</Title>
        <Paragraph>
          While we endeavour not to share your data with any other party, we may
          only share your data with our service partners that provide us IT
          services. Such sharing is only for the sole purpose of their updating
          maintaining or servicing the hardware or software that we use. Our
          service partners are provided access subject to their data protection
          and security controls being reviewed and deemed to be in conformance
          with this policy.
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>2. Other third parties</Title>
        <Paragraph>
          Except as set out above HairQ will never disclose your personal data
          to any third party, unless required to do so by law, governmental
          bodies, regulators, law enforcement agencies
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>3. Transfer of Data outside the EU</Title>
        <Paragraph>
          We may from time to time share your data with service partners from
          outside the EU. We apply firstly the same rigour as for EU service
          partners and secondly that such transfer complies with all relevant EU
          laws and regulations.
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Length of Data Retention</Title>
        <Paragraph>
          Data is retained only for the length of time that is necessary for the
          purpose for which it was collected, or longer if so required by any
          relevant law or regulation.{" "}
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Your Legal Rights to Your Personal Data Held by Us</Title>
        <Paragraph>
          The law gives you legal rights about your personal data. Accordingly
          you have the following rights about your personal data in our
          possession:
          <ul>
            <li>
              the right to restrict processing or use without your express
              authority
            </li>
            <li>
              the right of access - to ask for a copy of personal data that we
              hold about you. You exercise this right by asking for a copy of
              the data, which is commonly known as making a ‘subject access
              request’
            </li>
            <li>
              the right of rectification - to ask us to correct any errors
            </li>
            <li>
              the right to object or raise concern - to opt out of any marketing
              communications that we may send you, are concerned about its
              security, accuracy, confidentiality or any other aspect
            </li>
            <li>
              the right to data portability - to ask us to supply the data in a
              format accessible to you or other parties that you authorise. We
              must do this if the transfer is technically feasible
            </li>
            <li>
              the right to be forgotten - to request us to delete the data if we
              have no legal basis to retain it
            </li>
            <li>
              the right to object to automated individual decision-making and
              profiling or automated processing - decisions made about you
              without people involvement
            </li>
            <li>
              right to seek compensation if you suffer damage as a result of any
              breach
            </li>
          </ul>
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Your Role in Protecting your Own Data</Title>
        <Paragraph>
          We never ask for any bank account or credit card details via email. So
          any such emails must be duly deleted without being responded to.
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Legal Basis for Using Data</Title>
        <Paragraph>
          We are required by law to set out the legal basis upon which we
          process personal data. Accordingly;
          <br />
          HairQ collects and uses customers’ personal data because it is
          necessary for the provision of the services that we provide to you,
          promoting, marketing and advertising our products and services;
          complying with our legal or regulatory obligations; administration of
          our customer loyalty programme; or maintaining customer contacts,
          queries, complaints or disputes.
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Data Security Breaches</Title>
        <Paragraph>
          Despite our great efforts IT changes so fast that there is always an
          inherent risk that a data breach may still occur. In the event of a
          data security breach we will promptly notify our customers and service
          partners in order to minimise the damage and exposure that such breach
          occasions
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Additional Information</Title>
        <Paragraph>
          For any further questions regarding how HairQ use your personal data
          or to exercise your legal rights stated above please contact us by
          email: <a href="mailTo:customer@hairq.co.uk">customer@hairq.co.uk</a>
          You can also contact the Information Commissioner’s Office:
          <br />
          <a href="https://ico.org.uk/global/contact-us/">
            https://ico.org.uk/global/contact-us/
          </a>{" "}
          or by post Wycliffe House Water Lane Wilmslow Cheshire SK9 5AF or Tel:
          03031231113.
        </Paragraph>
      </ContentDiv>
      <ContentDiv>
        <Title>Last Update</Title>
        <Paragraph>HairQ last updated the policy in March 2021.</Paragraph>
      </ContentDiv>
    </MainDiv>
  );
}

export default PrivacyPolicy;
